export default __webpack_public_path__ + "static/media/lightbulb.9b141d4b.svg";